import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, H2, Reviews } from '../../components';

import css from './ListingPage.module.css';

const HIDDEN_REVIEW_ID = '69a525c4-20ef-42b4-9222-474c3205bae3';

const SectionReviews = props => {
  const { reviews = [], fetchReviewsError } = props;

  // filter review
  const filteredReviews = reviews.filter(
    r => r?.id?.uuid !== HIDDEN_REVIEW_ID
  );

  return (
    <section className={css.sectionReviews}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage
          id="ListingPage.reviewsTitle"
          values={{ count: filteredReviews.length }}
        />
      </Heading>

      {fetchReviewsError ? (
        <H2 className={css.errorText}>
          <FormattedMessage id="ListingPage.reviewsError" />
        </H2>
      ) : null}

      <Reviews reviews={filteredReviews} />
    </section>
  );
};

export default SectionReviews;